import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectParameters = () => createSelector(substate, (contextState) => contextState.parameters);
